import React from 'react';

import Css from './ImagePanel.scss';

import JsiLogo from '@components/JsiLogo/JsiLogo';

const ImagePanel = props => {
  let heightStyle = {
    height: props.screenHeight + 'px'
  };

  return (
    <div
      id={props.id}
      className={'panel d-flex align-items-center justify-content-center'}
      style={heightStyle}
    >
      <div className={'h-100'}>
        <img
          src={props.image}
          alt={'Slider1'}
          className={Css['slider-img'] + ' img-fluid ' + props.className}
        />
      </div>
      <JsiLogo className={props.jsiClass} />
      {props.children}
    </div>
  );
};

export default ImagePanel;



// WEBPACK FOOTER //
// ./src/components/ImagePanel/ImagePanel.js